import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

/**
 * returns DLS TextArea component
 * @param {*} props
 */
const HeadingComponent = (props) => {
  const {
    cssProperties,
    fieldLabel,
    setFormSubmissionPayload,
    formSubmissionPayload,
    variant,
  } = props;
  const CustomTag = `h${variant}`;
  useEffect(() => {
    // to retain values on back button.
    setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null });
  }, [fieldLabel]);

  return (
    <CustomTag className={cssProperties.style}>
      {parseHtml(fieldLabel)}
    </CustomTag>
  );
};

HeadingComponent.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  variant: PropTypes.string,
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default HeadingComponent;
